import React from "react";
import { cn } from "../../../../lib/utils";

export function Subtitle({ children, className }) {
	return React.cloneElement(children, {
		className: cn(
			"font-medium text-white",
			"mt-4 mb-4 text-[24px] leading-[32px]",
			"laptop:mt-6 laptop:mb-4 laptop:text-[32px] laptop:leading-[48px]",
			children.props.className,
			className,
		),
	});
}
